<template>
    <div>
        <PageHeader>
            {{ $t('widgeterReportsPages.title') }}
            <template #side>
                <div class="d-flex">
                    <MultiselectSpaces
                        v-model="pages"
                        class="width-250"
                        :disabled="isSpaceReportLoading"
                        :preselect-all="true"
                        @loading="value => isSpacesLoading = value"
                    />

                    <div class="mx-2"></div>

                    <TimeRangeCalendar v-model="timeRange" :disabled="loading" />
                </div>
            </template>
        </PageHeader>

        <div class="d-flex flex-column gap-3">

            <div class="d-flex gap-3 flex-wrap">
                <MultiEChartCard class="flex-basis-0 flex-grow-2" :data="lineChartData" :height="400" :loading="loading" @currentChart="setCurrentChart" />
                <EChart card :height="400" :options="pieChartData[currentChart]" :loading="loading" class="flex-basis-0 flex-grow-1 m-0 p-0" />
            </div>

            <SiteStatistics :space-ids="spaceIds || []" :time-range="timeRange || {}" />

        </div>
    </div>
</template>



<script>
    import ReportsPages from '@/views/common/reports/pages/index.vue';

    export default {
        name: 'WidgeterReportsPages',
        mixins: [ReportsPages],
        data() {
            return {
                isSpacesLoading: true,
            };
        },
        computed: {
            loading() {
                return this.isSpaceReportLoading || this.isSpacesLoading;
            },
        },
    };
</script>
